import { render } from "./MainGameManager.vue?vue&type=template&id=3b6681fb"
import script from "./MainGameManager.vue?vue&type=script&lang=js"
export * from "./MainGameManager.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__